// THƯ VIỆN SẢN PHẨM trên Boss (docs/thiet-ke-thu-vien-san-pham.md): kiểu + hàm thuần dùng chung cho máy chủ, trang web và phần dịch sơ đồ.
// Một sản phẩm = Hồ sơ sản phẩm của plugin (shared/ho-so.ts) cộng danh sách tệp gốc (chữ đã trích) + ảnh lưu trên máy chủ. Kịch bản sơ đồ
// giữ BẢN CHỤP (SanPhamSoDo) để bản dịch sơ đồ → bundle vẫn tất định, không đọc DB.
import { HO_SO_TAI_LIEU_TOI_DA, type HoSoSanPham, type TomTatSanPham } from "./ho-so";

export const SP_TEN_TOI_DA = 80; // như hồ sơ plugin (nhập hồ sơ plugin lên Boss không bị cắt)
export const SP_TEP_TOI_DA = 20;
export const SP_DONG_TOI_DA = 30; // số quy tắc / ghi nhớ
export const SP_MUC_TOI_DA = 300; // ký tự mỗi quy tắc / ghi nhớ / ý tóm tắt
export const SP_TOM_TAT_TOI_DA = 2000;
export const SP_MO_TA_TOI_DA = 1200; // = GIOI_HAN_SO_DO.hoSoMoTa (không import so-do.ts để tránh vòng)
export const SP_ID = /^sp-[a-z0-9]{6,32}$/;

export interface TepSanPham { ten: string; loai: string; kichThuoc: number; chu: string }
export interface AnhSanPham { id: string; mime: string; rong: number; cao: number; kichThuoc: number; moTa?: string } // moTa: chú thích ngắn (kho ảnh — bình luận kèm ảnh)
export interface SanPham {
  id: string;
  ownerId: string;
  ownerName?: string | null;
  ten: string;
  taiLieuDan: string;
  tep: TepSanPham[];
  taiLieu: string; // = gopTaiLieu(tep, taiLieuDan)
  anh: AnhSanPham[];
  tomTat: TomTatSanPham | null;
  tomTatLuc: string | null;
  tomTatGhiChu: string | null;
  quyTac: string[];
  ghiNho: string[];
  phienBan: number;
  taoLuc: string;
  suaLuc: string;
}
/** Bản chụp sản phẩm nằm trong sơ đồ kịch bản (SoDo.hoSo.thuVien). */
export interface SanPhamSoDo { id: string; phienBan: number; ten: string; taiLieu: string; tomTat?: TomTatSanPham; quyTac: string[]; ghiNho: string[] }

export class LoiSanPham extends Error {}

const dem = (s: string) => Array.from(s).length;
const motDong = (s: string) => s.replace(/\s+/g, " ").trim();

/** Bỏ ký tự YAML/JSON không chấp nhận hoặc vô hình gây hỏng (C0 trừ tab/xuống dòng, C1, BOM, U+FFFE/FFFF, nửa cặp surrogate); U+2028/2029 → xuống dòng; NFC. */
export function lamSachChu(s: string): string {
  return String(s ?? "")
    .replace(/[\u2028\u2029]/g, "\n")
    .replace(/\r\n?/g, "\n")
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\uFEFF\uFFFE\uFFFF]/g, "")
    .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, "")
    .normalize("NFC");
}

/** Tài liệu đầy đủ = chữ từng tệp (có dòng tiêu đề nguồn) + chữ dán. Chỉ có chữ dán → giữ nguyên chữ dán. */
export function gopTaiLieu(tep: TepSanPham[], dan: string): string {
  const phan = tep.filter((t) => t.chu.trim()).map((t) => `=== Tệp: ${t.ten} ===\n${t.chu.trim()}`);
  const d = dan.trim();
  if (!phan.length) return d;
  if (d) phan.push(`=== Chữ dán thêm ===\n${d}`);
  return phan.join("\n\n");
}

const dsChu = (v: unknown, toiDaMuc: number, toiDaDai: number, nhan: string, loi: string[]): string[] => {
  if (v === undefined || v === null) return [];
  if (!Array.isArray(v)) { loi.push(`${nhan} phải là danh sách`); return []; }
  const out = [...new Set(v.map((x) => lamSachChu(typeof x === "string" ? x : String(x ?? "")).replace(/\s+/g, " ").trim()).filter(Boolean))];
  if (out.length > toiDaMuc) loi.push(`${nhan} tối đa ${toiDaMuc} mục`);
  out.forEach((x, i) => { if (dem(x) > toiDaDai) loi.push(`${nhan} ${i + 1} quá dài (tối đa ${toiDaDai} ký tự)`); });
  return out;
};

/** Chuẩn hoá tóm tắt (AI trả hoặc người sửa tay). null = không có / bỏ. */
export function chuanTomTat(v: unknown, loi: string[]): TomTatSanPham | null {
  if (v === undefined || v === null) return null;
  if (typeof v !== "object" || Array.isArray(v)) { loi.push("Tóm tắt không hợp lệ"); return null; }
  const o = v as Record<string, unknown>;
  const tomTat = lamSachChu(typeof o.tom_tat === "string" ? o.tom_tat : "").trim();
  if (!tomTat) return null;
  if (dem(tomTat) > SP_TOM_TAT_TOI_DA) loi.push(`Tóm tắt quá dài (tối đa ${SP_TOM_TAT_TOI_DA} ký tự)`);
  const khach = lamSachChu(typeof o.khach_muc_tieu === "string" ? o.khach_muc_tieu : "").replace(/\s+/g, " ").trim();
  if (dem(khach) > SP_MUC_TOI_DA) loi.push(`Khách mục tiêu quá dài (tối đa ${SP_MUC_TOI_DA} ký tự)`);
  const t: TomTatSanPham = {
    tom_tat: tomTat,
    diem_noi_bat: dsChu(o.diem_noi_bat, 10, SP_MUC_TOI_DA, "Điểm nổi bật", loi),
    khach_muc_tieu: khach,
    khong_noi: dsChu(o.khong_noi, 10, SP_MUC_TOI_DA, "Điều không nói", loi),
  };
  const tuAnh = dsChu(o.tu_anh, 10, SP_MUC_TOI_DA, "Điều đọc từ ảnh", loi);
  if (tuAnh.length) t.tu_anh = tuAnh;
  return t;
}

/** Kiểm + chuẩn hoá danh sách tệp (chữ đã trích). */
export function chuanTep(v: unknown, loi: string[]): TepSanPham[] {
  if (v === undefined || v === null) return [];
  if (!Array.isArray(v)) { loi.push("Danh sách tệp không hợp lệ"); return []; }
  if (v.length > SP_TEP_TOI_DA) loi.push(`Tối đa ${SP_TEP_TOI_DA} tệp mỗi sản phẩm`);
  const out: TepSanPham[] = [];
  v.slice(0, SP_TEP_TOI_DA).forEach((x, i) => {
    const o = (x && typeof x === "object" && !Array.isArray(x) ? x : {}) as Record<string, unknown>;
    const ten = lamSachChu(typeof o.ten === "string" ? o.ten : "").replace(/[\\/\n\t]/g, " ").trim().slice(0, 200);
    const chu = lamSachChu(typeof o.chu === "string" ? o.chu : "").trim();
    const kt = typeof o.kichThuoc === "number" && Number.isFinite(o.kichThuoc) && o.kichThuoc >= 0 ? Math.round(o.kichThuoc) : 0;
    if (!ten) { loi.push(`Tệp ${i + 1} thiếu tên`); return; }
    if (!chu) { loi.push(`Tệp “${ten}” không có chữ`); return; }
    const loai = (/\.[^.]+$/.exec(ten)?.[0] ?? "").toLowerCase().slice(0, 10);
    out.push({ ten, loai, kichThuoc: kt, chu });
  });
  return out;
}

/** Kiểm tổng tài liệu ≤ HO_SO_TAI_LIEU_TOI_DA (như plugin). */
export function loiDoDaiTaiLieu(taiLieu: string): string | null {
  const n = dem(taiLieu);
  return n > HO_SO_TAI_LIEU_TOI_DA ? `Tài liệu quá dài (${n.toLocaleString("vi-VN")} ký tự, tối đa ${HO_SO_TAI_LIEU_TOI_DA.toLocaleString("vi-VN")}) — bỏ bớt tệp hoặc cắt gọn phần cốt lõi` : null;
}

export function kiemTenSanPham(v: unknown): string {
  const ten = lamSachChu(typeof v === "string" ? v : "").replace(/\s+/g, " ").trim();
  if (!ten) throw new LoiSanPham("Sản phẩm cần có tên");
  if (dem(ten) > SP_TEN_TOI_DA) throw new LoiSanPham(`Tên sản phẩm tối đa ${SP_TEN_TOI_DA} ký tự`);
  if (ten.includes("{{")) throw new LoiSanPham("Tên sản phẩm không được chứa “{{”");
  return ten;
}

export const chuanQuyTac = (v: unknown, loi: string[]): string[] => dsChu(v, SP_DONG_TOI_DA, SP_MUC_TOI_DA, "Quy tắc", loi);
export const chuanGhiNho = (v: unknown, loi: string[]): string[] => dsChu(v, SP_DONG_TOI_DA, SP_MUC_TOI_DA, "Ghi nhớ", loi);

// ---------------- bản chụp trong sơ đồ ----------------
// Cắt chữ về ≤ toiDa ký tự (đếm theo ký tự thật — emoji không bị cắt đôi): ưu tiên cắt ở khoảng trắng gần cuối, thêm "…". Ngắn hơn → giữ nguyên.
function rutGonChu(s: string, toiDa: number): string {
  const kt = Array.from(s);
  if (kt.length <= toiDa) return s;
  let phan = kt.slice(0, toiDa - 1).join("");
  const cat = phan.search(/\s\S*$/);
  if (cat >= Math.floor(phan.length * 0.6)) phan = phan.slice(0, cat);
  return `${phan.trimEnd()}…`;
}

/** Đưa tóm tắt về đúng giới hạn (mỗi ý ≤ SP_MUC_TOI_DA, tóm tắt ≤ SP_TOM_TAT_TOI_DA, ≤ 10 ý mỗi danh sách). (05/10/2026) AI tóm tắt / đọc ảnh có khi
 *  trả ý > 300 ký tự; trước đây máy chủ lưu nguyên rồi khi gắn sản phẩm vào kịch bản thì bị chuanBanChup từ chối ("Điều đọc từ ảnh 1 quá dài").
 *  Tóm tắt đã hợp lệ → trả lại y nguyên (bản chụp/hash kịch bản cũ không đổi). */
export function rutGonTomTat(t: TomTatSanPham): TomTatSanPham {
  const ds = (a: string[] | undefined): string[] => (a ?? []).slice(0, 10).map((x) => rutGonChu(x, SP_MUC_TOI_DA));
  const r: TomTatSanPham = { tom_tat: rutGonChu(t.tom_tat, SP_TOM_TAT_TOI_DA), diem_noi_bat: ds(t.diem_noi_bat), khach_muc_tieu: rutGonChu(t.khach_muc_tieu ?? "", SP_MUC_TOI_DA), khong_noi: ds(t.khong_noi) };
  if (t.tu_anh) r.tu_anh = ds(t.tu_anh);
  return r;
}

export function banChupSanPham(sp: Pick<SanPham, "id" | "phienBan" | "ten" | "taiLieu" | "tomTat" | "quyTac" | "ghiNho">): SanPhamSoDo {
  const b: SanPhamSoDo = { id: sp.id, phienBan: sp.phienBan, ten: sp.ten, taiLieu: sp.taiLieu, quyTac: [...sp.quyTac], ghiNho: [...sp.ghiNho] };
  // Sản phẩm lưu trước 05/10 có thể có ý tóm tắt quá dài (AI) → rút gọn khi chụp để gắn được vào kịch bản (không cần tóm tắt lại).
  if (sp.tomTat) b.tomTat = rutGonTomTat(JSON.parse(JSON.stringify(sp.tomTat)) as TomTatSanPham);
  return b;
}

/** "Mô tả" (một dòng, ≤ 1200) tính từ bản chụp: tóm tắt AI nếu có, không thì đầu tài liệu. Dùng cho luật L-16 + lời kịch bản + AI viết sơ đồ. */
export function moTaTuThuVien(sp: Pick<SanPhamSoDo, "taiLieu" | "tomTat">): string {
  return Array.from(motDong(sp.tomTat?.tom_tat || sp.taiLieu)).slice(0, SP_MO_TA_TOI_DA).join("");
}

/** Kiểm cấu trúc bản chụp (từ DB, tệp nhập hoặc YAML). Trả null + lỗi khi sai. */
export function chuanBanChup(v: unknown, loi: string[]): SanPhamSoDo | null {
  if (!v || typeof v !== "object" || Array.isArray(v)) { loi.push("Sản phẩm thư viện không hợp lệ"); return null; }
  const o = v as Record<string, unknown>;
  const truoc = loi.length;
  const id = typeof o.id === "string" && SP_ID.test(o.id) ? o.id : "";
  if (!id) loi.push("Mã sản phẩm thư viện không hợp lệ");
  const pb = typeof o.phienBan === "number" && Number.isInteger(o.phienBan) && o.phienBan >= 1 ? o.phienBan : 0;
  if (!pb) loi.push("Phiên bản sản phẩm thư viện không hợp lệ");
  let ten = "";
  try { ten = kiemTenSanPham(o.ten); } catch (e) { loi.push((e as Error).message); }
  const taiLieu = lamSachChu(typeof o.taiLieu === "string" ? o.taiLieu : "").trim();
  const ld = loiDoDaiTaiLieu(taiLieu);
  if (ld) loi.push(ld);
  const tomTat = chuanTomTat(o.tomTat, loi);
  const quyTac = chuanQuyTac(o.quyTac, loi), ghiNho = chuanGhiNho(o.ghiNho, loi);
  if (loi.length > truoc) return null;
  const b: SanPhamSoDo = { id, phienBan: pb, ten, taiLieu, quyTac, ghiNho };
  if (tomTat) b.tomTat = tomTat;
  return b;
}

/** Bản chụp → HoSoSanPham (để dùng knowledgeTuHoSo của plugin y hệt). */
export function hoSoTuBanChup(sp: SanPhamSoDo): HoSoSanPham {
  return { id: sp.id, ten: sp.ten, taiLieu: sp.taiLieu, ...(sp.tomTat ? { tomTat: sp.tomTat } : {}), quyTac: sp.quyTac, ghiNho: sp.ghiNho, capNhatLuc: "" };
}

/** L-16 cho sản phẩm thư viện: không tóm tắt và tài liệu < 40 ký tự → AI phải đoán sản phẩm là gì. */
export function loiTaiLieuThuVien(sp: SanPhamSoDo, toiThieu: number): string | null {
  const n = dem(moTaTuThuVien(sp));
  if (n >= toiThieu) return null;
  return `Sản phẩm “${sp.ten}” trong thư viện có tài liệu quá ngắn (${n}/${toiThieu} ký tự) và chưa có tóm tắt — AI soạn nội dung chỉ được nói điều có trong tài liệu. Hãy mở trang Sản phẩm, thêm tài liệu (tệp hoặc chữ dán) rồi bấm “AI tóm tắt”`;
}

/** Dòng mô tả sản phẩm cho lời nhắc AI viết/sửa sơ đồ và Trợ lý: tên — tóm tắt; + điểm nổi bật + quy tắc (gọn). */
export function moTaSanPhamChoAi(hoSo: { ten: string; moTa: string; thuVien?: SanPhamSoDo }): string {
  const tv = hoSo.thuVien;
  if (!tv) return `${hoSo.ten} — ${hoSo.moTa}`;
  const phan = [`${tv.ten} — ${moTaTuThuVien(tv)}`];
  if (tv.tomTat?.diem_noi_bat.length) phan.push(`Điểm nổi bật: ${tv.tomTat.diem_noi_bat.slice(0, 6).join("; ")}`);
  if (tv.tomTat?.khach_muc_tieu) phan.push(`Khách mục tiêu: ${tv.tomTat.khach_muc_tieu}`);
  if (tv.quyTac.length) phan.push(`Quy tắc của sản phẩm: ${tv.quyTac.slice(0, 10).join("; ")}`);
  if (tv.tomTat?.khong_noi.length) phan.push(`Không nói: ${tv.tomTat.khong_noi.slice(0, 6).join("; ")}`);
  return phan.join(" · ");
}

// ---------------- ảnh: đọc kích thước từ đầu tệp (không cần thư viện) ----------------
export type MimeAnhSp = "image/jpeg" | "image/png" | "image/webp";
export function kichThuocAnh(b: Uint8Array): { mime: MimeAnhSp; rong: number; cao: number } | null {
  const u16be = (o: number) => (b[o]! << 8) | b[o + 1]!;
  const u32be = (o: number) => ((b[o]! << 24) | (b[o + 1]! << 16) | (b[o + 2]! << 8) | b[o + 3]!) >>> 0;
  if (b.length >= 24 && b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47 && b[12] === 0x49 && b[13] === 0x48 && b[14] === 0x44 && b[15] === 0x52) return { mime: "image/png", rong: u32be(16), cao: u32be(20) };
  if (b.length >= 4 && b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) {
    for (let o = 2; o + 9 < b.length;) {
      if (b[o] !== 0xff) { o++; continue; }
      const m = b[o + 1]!;
      if (m === 0xd8 || m === 0x01 || (m >= 0xd0 && m <= 0xd7) || m === 0xff) { o += m === 0xff ? 1 : 2; continue; }
      const dai = u16be(o + 2);
      if ((m >= 0xc0 && m <= 0xc3) || (m >= 0xc5 && m <= 0xc7) || (m >= 0xc9 && m <= 0xcb) || (m >= 0xcd && m <= 0xcf)) return { mime: "image/jpeg", rong: u16be(o + 7), cao: u16be(o + 5) };
      if (dai < 2) return null;
      o += 2 + dai;
    }
    return null;
  }
  if (b.length >= 30 && String.fromCharCode(...b.subarray(0, 4)) === "RIFF" && String.fromCharCode(...b.subarray(8, 12)) === "WEBP") {
    const loai = String.fromCharCode(...b.subarray(12, 16));
    if (loai === "VP8X") return { mime: "image/webp", rong: 1 + (b[24]! | (b[25]! << 8) | (b[26]! << 16)), cao: 1 + (b[27]! | (b[28]! << 8) | (b[29]! << 16)) };
    if (loai === "VP8 ") return { mime: "image/webp", rong: (b[26]! | (b[27]! << 8)) & 0x3fff, cao: (b[28]! | (b[29]! << 8)) & 0x3fff };
    if (loai === "VP8L") { const v = b[21]! | (b[22]! << 8) | (b[23]! << 16) | (b[24]! << 24); return { mime: "image/webp", rong: 1 + (v & 0x3fff), cao: 1 + ((v >>> 14) & 0x3fff) }; }
  }
  return null;
}
